// extracted by mini-css-extract-plugin
export default {"container":"CenteredContainer_container__jQwiw"};